import React from "react";
import CompaniesTable from "../components/Tables/CompaniesTable";
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import CircularProgress from '@material-ui/core/CircularProgress';
import CompanyModal from '../components/Modals/CompanyModal';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import TableTop from '../components/Tables/TableSiteTop';
import { loadCompanies } from "../actions/companyActions";
import compose from 'recompose/compose';
import { modalToggle } from '../actions/modalActions';
import  SnackbarMessage  from '../components/Layout/SnackbarMessage';
import { deleteCompany } from '../actions/companyActions';
import { addCompaniesSearchCriteria } from '../actions/searchActions';


const styles = theme => ({
  root: {
    flexGrow: 1,
    padding: 8,
    margin: 8
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
});

class CompaniesPage extends React.Component {
  componentDidMount() {
    const { loadCompanies } = this.props;
    loadCompanies();
  }


  state = {
    isModalOpen: false,
    // The modal is used for editing and creating.
    // Thus, the modal needs the information, which
    // functionality is to be used.
    useEditModal: false,
    // When clicking a table row, the row is hilighted and modal opened.
    // This property is used for removing the hilight when modal is closed.
    useSelectedRow: true,
    selectedCompany: null
  }

  handleCreateModalOpen = () => {
    this.setState({ isModalOpen: true });
    this.props.modalToggle(true);
  };

  handleCreateModalClose = () => {
    this.setState({ isModalOpen: false, useEditModal: false, useSelectedRow: false, selectedCompany: null });
    this.props.modalToggle(false);
  };

  handleRowClick = (company) => {
    this.props.modalToggle(true);
    this.setState({isModalOpen: true, useEditModal: true, useSelectedRow: true, selectedCompany: company});
  }

  handleCompanyDelete = async (company) => {
    if (this.props.isDeleting ) {
      return;
    }
    this.setState({ useSelectedRow: true, selectedCompany: company});
    let ans = window.confirm("Are you sure you want to delete this Company?");
    if(ans) {
      await this.props.deleteCompany(company);
    }
    this.setState({ useSelectedRow: false, selectedCompany: null});
  }

  handleSearchFieldChange = (searchCriteria) => {
    this.props.addCompaniesSearchCriteria(searchCriteria);
  }

  render() {
    const {classes, companies, role} = this.props;
    const { isModalOpen, useEditModal, useSelectedRow, selectedCompany } = this.state;
    const { handleCreateModalOpen, handleCreateModalClose } = this;

    return (
      <div className={classes.root}>
        <TableTop role={role} handleModalOpen={handleCreateModalOpen} isButtonDisabled={(companies.isLoading || companies.hasErrored)} headlineText="Companies"/>
        <Grid container spacing={24} alignItems="center">
      {companies.hasFailed && (
        <Grid item xs={12}>
          <Typography>Error</Typography>
        </Grid>
      )}
      {companies.isLoading && (
        <Grid item xs={12}>
          <CircularProgress className={classes.progress} size={50} />
        </Grid>
      )}
      {companies.companiesData != null && companies.companiesData.length > 0 && (
        <Grid item xs={12}>
          <CompaniesTable
            role = {role}
            handleCompanyDelete={this.handleCompanyDelete}
            useSelectedRow={useSelectedRow}
            handleRowClick={this.handleRowClick}
            companies={companies.companiesData}
            handleSearchFieldChange={this.handleSearchFieldChange}
            searchFieldValues={this.props.searchFieldValues.companies}
          />
        </Grid>
      )}
      </Grid>
      <CompanyModal selectedCompany={selectedCompany} isEdit={useEditModal} isOpen={isModalOpen} handleClose={handleCreateModalClose}/>
      <SnackbarMessage />
    </div>

    )
  }
}

CompaniesPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
  return {
    companies: state.company.companies,
    isDeleting: state.company.companies.isDeleting,
    searchFieldValues: state.searchField,
    role: (state.oidc.user && state.oidc.user.profile) ? state.oidc.user.profile.identity_role : null,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadCompanies: () => {
      dispatch(loadCompanies())
    },
    modalToggle: (value) => {
      dispatch(modalToggle(value));
    },
    deleteCompany: (company) => {
      dispatch(deleteCompany(company))
    },
    addCompaniesSearchCriteria: (searchField) => {
      dispatch(addCompaniesSearchCriteria(searchField))
    }
  }
}

export default
  compose(
    withStyles(styles),
    connect(mapStateToProps, mapDispatchToProps)
  )(CompaniesPage);



// WEBPACK FOOTER //
// ./src/containers/CompaniesPage.js